import React, { useState, useEffect } from 'react';
import { X, Apple, PlayCircle } from 'lucide-react';

const APP_IMAGE = 'https://customer-assets.emergentagent.com/job_9bdcd575-ddaa-42d7-a8cc-d8ffc998707a/artifacts/oxtmxbxs_ChatGPT%20Image%20Mar%2025%2C%202026%2C%2006_34_18%20PM.png';

const FloatingAppPanel = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Don't show if already dismissed this session
    if (sessionStorage.getItem('vietclinics_app_panel_dismissed')) {
      return;
    }

    const onScroll = () => {
      if (window.scrollY > 650) {
        setIsVisible(true);
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    sessionStorage.setItem('vietclinics_app_panel_dismissed', 'true');
  };

  if (isDismissed || !isVisible) return null;

  return (
    <div
      className="fixed right-0 top-1/2 -translate-y-1/2 z-40 hidden lg:block"
      style={{
        animation: 'slideInRight 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards',
      }}
      data-testid="app-panel"
    >
      <style>{`
        @keyframes slideInRight {
          from { transform: translateY(-50%) translateX(100%); opacity: 0; }
          to   { transform: translateY(-50%) translateX(0);   opacity: 1; }
        }
      `}</style>

      <div className="bg-white rounded-l-2xl border border-gray-100 border-r-0 overflow-hidden" style={{ width: 176, boxShadow: '0 8px 40px rgba(0,0,0,0.14)' }}>
        {/* Dismiss */}
        <button
          onClick={handleDismiss}
          className="absolute top-2 left-2.5 z-10 text-white/70 hover:text-white transition-colors"
          data-testid="app-panel-close"
          aria-label="Close app panel"
        >
          <X className="h-3.5 w-3.5" />
        </button>

        {/* Header + image */}
        <div className="relative bg-gradient-to-br from-[#1FA7A1] to-[#1E5BA8] pt-7 pb-0 px-3 flex justify-center overflow-hidden">
          {/* Background glow */}
          <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(circle at 50% 80%, rgba(255,255,255,0.1) 0%, transparent 70%)' }} />
          <img
            src={APP_IMAGE}
            alt="VietClinics App"
            className="relative z-10 object-contain"
            style={{ width: 110, maxHeight: 160, filter: 'drop-shadow(0 8px 20px rgba(0,0,0,0.25))' }}
          />
        </div>

        {/* Content */}
        <div className="p-3">
          <p data-testid="app-panel-status" className="font-extrabold text-gray-900 text-[13px] leading-tight mb-0.5">App Coming Soon</p>
          <p className="text-[10px] text-gray-500 mb-3 leading-snug">Not yet available to download</p>

          {/* Features */}
          <div className="space-y-1 mb-3">
            {['Enquiry-led coordination', 'Provider-confirmed appointments', 'Clinical decisions by providers'].map((f) => (
              <div key={f} className="flex items-center gap-1.5">
                <div className="w-1.5 h-1.5 bg-[#2ECC71] rounded-full flex-shrink-0" />
                <span className="text-[10px] text-gray-600">{f}</span>
              </div>
            ))}
          </div>

          {/* Download buttons */}
          <div className="space-y-1.5">
            <a
              href="#"
              className="flex items-center justify-center gap-2 w-full bg-gray-900 hover:bg-black text-white py-2 rounded-xl transition-colors"
              data-testid="app-panel-appstore"
            >
              <Apple className="h-3.5 w-3.5" />
              <div>
                <div className="text-[7px] leading-none opacity-70">Coming soon</div>
                <div className="text-[11px] font-bold leading-tight">App Store</div>
              </div>
            </a>
            <a
              href="#"
              className="flex items-center justify-center gap-2 w-full bg-gray-900 hover:bg-black text-white py-2 rounded-xl transition-colors"
              data-testid="app-panel-googleplay"
            >
              <PlayCircle className="h-3.5 w-3.5" />
              <div>
                <div className="text-[7px] leading-none opacity-70">Coming soon</div>
                <div className="text-[11px] font-bold leading-tight">Google Play</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FloatingAppPanel;
